import { render, staticRenderFns } from "./accounts-list.vue?vue&type=template&id=221346d0&"
import script from "./accounts-list.vue?vue&type=script&lang=js&"
export * from "./accounts-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports